import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import React, { useCallback } from "react";

export default function useTrackEvent(condition = true) {
  const sendDataToGTM = useGTMDispatch();

  const trackEvent = useCallback(
    (eventName, eventData) => {
      try {
        if (!condition) return;
        sendDataToGTM({
          event: eventName,
          ...eventData,
          timestamp: new Date().toISOString(),
        });
      } catch (error) {
        console.error("Failed to send GTM event:", error);
      }
    },
    [sendDataToGTM, condition]
  );

  return trackEvent;
}
